import { QueryHookOptions, useQuery } from '@apollo/client';

import { UNIT_QUERY } from './queries';
import { Unit } from './types';

export const useUnits = (options?: QueryHookOptions) => useQuery<{ units: Unit[] }>(UNIT_QUERY, { ...options });
